var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feature-card-container flex-centerize flex-row"},[_c('AppIcon',{staticClass:"workflow-icon",attrs:{"name":_vm.workflowTypeIconName,"width":"17"}}),(_vm.integrationIconName)?_c('AppIcon',{staticClass:"integration-icon ml-3",attrs:{"name":_vm.integrationIconName,"width":"20"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }